export default "__VITE_ASSET__DIZgsYFR__"